module.exports = __webpack_public_path__ + "img/icon_minus_black.adef950e.svg";